const AppImages = {
  Ellipse9: require("../Assets/images/Ellipse9.png"),
  Ellipse10: require("../Assets/images/Ellipse10.png"),
  flag1: require("../Assets/images/flag1.png"),
  flag2: require("../Assets/images/flag2.png"),
  LineD: require("../Assets/images/LineD.png"),
  LineL: require("../Assets/images/LineL.png"),
  Line: require("../Assets/images/Line.png"),
  Triangle: require("../Assets/images/triangle.png"),
  Clock: require("../Assets/images/Clock.png"),
  Calendar: require("../Assets/images/Calendar.png"),
  Search1: require("../Assets/images/Search1.png"),
  Ellipse: require("../Assets/images/Ellipse.png"),
  Ellipse6: require("../Assets/images/Ellipse6.png"),
  Ellipse7: require("../Assets/images/Ellipse7.png"),
  export: require("../Assets/images/export.png"),
  Blankflag: require("../Assets/images/blankflag.png"),
  Flag: require("../Assets/images/flag.png"),
  tick: require("../Assets/images/tick.png"),
  circle: require("../Assets/images/circle.png"),
  Ellipse2: require("../Assets/images/Ellipse2.png"),
  cross: require("../Assets/images/Delpic.png"),
  location: require("../Assets/images/location.png"),
  carnoti: require("../Assets/images/carnoti.png"),
  bellnoti1: require("../Assets/images/bellnoti1.png"),
  Ellipse8: require("../Assets/images/Ellipse8.png"),
  line2: require("../Assets/images/Line2.png"),
  //------------------Rahil ------------------------//
  Others: require("../Assets/images/Others.png"),
  BarGraphInsight: require("../Assets/images/BarGraphInsight.png"),
  DeviceLogin: require("../Assets/images/DeviceLogin.png"),
  DriverR: require("../Assets/images/DriverA.png"),
  Assistant: require("../Assets/images/Assistant.png"),
  BusFleet: require("../Assets/images/BusFleet.png"),
  SettingsCar: require("../Assets/images/SettingsCar.png"),
  ManLock: require("../Assets/images/ManLock.png"),
  EditOption: require("../Assets/images/EditOption.png"),
  QuestionPic: require("../Assets/images/QuestionPic.png"),
  DiverDp: require("../Assets/images/DiverDp.png"),
  ProfileCar: require("../Assets/images/ProfileCarR.png"),
  BatteryLife: require("../Assets/images/BatteryLife.png"),
  UpArrowGreen: require("../Assets/images/UpArrowGreen.png"),
  BatteryStatus: require("../Assets/images/batteryStatus.png"),
  BatteryVoltage: require("../Assets/images/BatteryVoltage.png"),
  HealthMsg: require("../Assets/images/HealthMessage.png"),
  Healthy: require("../Assets/images/HEalthy.png"),
  Panic: require("../Assets/images/Panic.png"),
  Running: require("../Assets/images/RunningStatus.png"),
  CarLock: require("../Assets/images/CarLock.png"),
  CarBlock: require("../Assets/images/CarBlock.png"),
  BackgroundCarRed: require("../Assets/images/BackgroundCar.pngRed.png"),
  BackgroundGreenCar: require("../Assets/images/BackgroundGreenCar.png"),
  GrpImg: require("../Assets/images/GrpImg.png"),
  Import: require("../Assets/images/Import.png"),
  // export: require("../Assets/images/export.png"),
  // export: require("../Assets/images/export.png"),
  ToyCar: require("../Assets/images/ToyCar.png"),
  ToyCarYellow: require("../Assets/images/YellowToy.png"),
  ToyCarSky: require("../Assets/images/skytoy.png"),
  Toy1: require("../Assets/images/Toy1.png"),
  Toy2: require("../Assets/images/Toy2.png"),
  Toy3: require("../Assets/images/Toy3.png"),
  Toy4: require("../Assets/images/Toy4.png"),
  Toy5: require("../Assets/images/Toy5.png"),
  ToyRed: require("../Assets/images/RedTichkCars.png"),
  Toy7: require("../Assets/images/Toy2.png"),
  ToyREdToy: require("../Assets/images/RedToy.png"),
  ToyBlackcar: require("../Assets/images/blackcar.png"),
  ToyBluecar: require("../Assets/images/bluecar.png"),
  Toy8: require("../Assets/images/Toy2.png"),
  Toy6: require("../Assets/images/toy6.png"),
  Toy9: require("../Assets/images/Toy2.png"),
  Car: require("../Assets/images/Car.png"),
  LineImg: require("../Assets/images/LineImg.png"),
  LuxuryCar: require("../Assets/images/LuxuryCar.png"),
  Bike: require("../Assets/images/Bike.png"),
  LineBar: require("../Assets/images/LineBar.png"),
  ShadowCar: require("../Assets/images/ShadowCar.png"),
  ShadowBike: require("../Assets/images/ShadowBike.png"),
  UntrackedCar: require("../Assets/images/UntrackedCar.png"),
  UntrackedBike: require("../Assets/images/UntrackedBike.png"),
  VechicleNoti: require("../Assets/images/VehicleNoti.png"),
  NotiGreen: require("../Assets/images/NOtiGreen.png"),
  CutCar: require("../Assets/images/CutCar.png"),
  RoseNot: require("../Assets/images/RoseNot.png"),
  GreenTick: require("../Assets/images/GreenTrick.png"),
  Round: require("../Assets/images/Round.png"),
  Arrow: require("../Assets/images/arrow.png"),
  Calender: require("../Assets/images/Calender.png"),
  Import: require("../Assets/images/Import.png"),
  RectBox: require("../Assets/images/RectBox.png"),
  BrownTick: require("../Assets/images/BrownTick.png"),
  LuxuryBikes: require("../Assets/images/LuxuryBikes.png"),
  Car: require("../Assets/images/Car.png"),
  Bike: require("../Assets/images/Bike.png"),
  LineBar: require("../Assets/images/LineBar.png"),
  ShadowCar: require("../Assets/images/ShadowCar.png"),
  ShadowBike: require("../Assets/images/ShadowBike.png"),
  UntrackedCar: require("../Assets/images/UntrackedCar.png"),
  UntrackedBike: require("../Assets/images/UntrackedBike.png"),
  VechicleNoti: require("../Assets/images/VehicleNoti.png"),
  NotiGreen: require("../Assets/images/NOtiGreen.png"),
  CutCar: require("../Assets/images/CutCar.png"),
  RoseNot: require("../Assets/images/RoseNot.png"),
  GreenTick: require("../Assets/images/GreenTrick.png"),
  Round: require("../Assets/images/Round.png"),
  BackGroundYellowCar: require("../Assets/images/BackGroundYellowCar.png"),
  BackGroundSkyCar: require("../Assets/images/BackGroundSkyCar.png"),
  Calender: require("../Assets/images/Calender.png"),
  RedAcross: require("../Assets/images/RedAcross.png"),
  SeatingCapacity: require("../Assets/images/SeatingCapacity.png"),
  FuelTank: require("../Assets/images/FuelTank.png"),
  Kilometer: require("../Assets/images/Kilometer.png"),
  RepairCar: require("../Assets/images/RepairCar.png"),
  Sixteen: require("../Assets/images/Sixteen.png"),
  ParkingMarker: require("../Assets/images/ParkingMarker.png"),
  FuelSensor: require("../Assets/images/FuelSensor.png"),
  IButton: require("../Assets/images/IButton.png"),
  EcoDriver: require("../Assets/images/EchoDriver.png"),
  SeatBelt: require("../Assets/images/SeatBelt.png"),
  IVMS: require("../Assets/images/IVMS.png"),
  CardReader: require("../Assets/images/CardReader.png"),
  OverSpeed: require("../Assets/images/OverSpeed.png"),
  CrashDetecton: require("../Assets/images/CrashDetection.png"),
  ExcessiveIdling: require("../Assets/images/ExcessiveIdling.png"),
  TowingDetection: require("../Assets/images/TowingDetection.png"),
  TemperatureSenor: require("../Assets/images/TemperatureSenor.png"),
  UnplugDetection: require("../Assets/images/UnplugDetection.png"),
  FuelEmpty: require("../Assets/images/FuelEmpty.png"),
  NonIButton: require("../Assets/images/NonIButton.png"),
  NonEcho: require("../Assets/images/NonEcho.png"),
  NonSeatBelt: require("../Assets/images/NonSeatBelt.png"),
  NonIVMS: require("../Assets/images/NonIVMS.png"),
  NonReader: require("../Assets/images/NonReader.png"),
  NonOverSpeed: require("../Assets/images/NonOverSpeed.png"),
  NonCrash: require("../Assets/images/NonCrash.png"),
  NonExessive: require("../Assets/images/NonExcessive.png"),
  NonTowing: require("../Assets/images/NonTowing.png"),
  NonPlug: require("../Assets/images/NonPlug.png"),
  PayInvoice: require("../Assets/images/PayInvoice.png"),
  InvoicePaper: require("../Assets/images/InvoicePaper.png"),
  PaidList: require("../Assets/images/PaidList.png"),
  Printer: require("../Assets/images/Printer.png"),
  LineRecipt: require("../Assets/images/LineRecipt.png"),
  AudioPlay: require("../Assets/images/AudioPlay.png"),
  AudioMenu: require("../Assets/images/AudioMenu.png"),

  Right: require("../Assets/images/whiteArrowright.png"),
  Left: require("../Assets/images/whitearrowleft.png"),
  Down: require("../Assets/images/whiteArow1.png"),
  //------------------Reshma------------------------//
  Ellipse3: require("../Assets/images/Ellipse3.png"),
  Ellipse4: require("../Assets/images/Ellipse4.png"),
  Ellipse5: require("../Assets/images/Ellipse5.png"),
  LoginLogo: require("../Assets/images/VehicleLogo.png"),
  VehicleLogin: require("../Assets/images/VehicleLogin.png"),
  WhiteRoundBack: require("../Assets/images/WhiteRouundBack.png"),
  ToolsMap: require("../Assets/images/ToolsMap.png"),
  WhiteRoundmap: require("../Assets/images/WhiteRoundMap.png"),
  TripsMap: require("../Assets/images/YellowTripMap.png"),
  GreenCarMap: require("../Assets/images/GreenCarMap.png"),
  RedCarMap: require("../Assets/images/RedCarMap.png"),
  searchbar: require("../Assets/images/Searchbar.png"),
  Plus: require("../Assets/images/Plus.png"),
  Backbtn: require("../Assets/images/Backbtn.png"),
  Bellnoti: require("../Assets/images/Bellnoti.png"),
  BottomDashboard: require("../Assets/images/DashboardBottom.png"),
  BottomSetting: require("../Assets/images/BottomSetting.png"),
  MessageBottom: require("../Assets/images/MessageBottom.png"),
  ProfileBottom: require("../Assets/images/ProfileBottom.png"),
  TripBottom: require("../Assets/images/TripBottom.png"),
  GreenbusMapbottom: require("../Assets/images/GreenbusMapbottom.png"),
  RedbusMapbottom: require("../Assets/images/RedbusMapbottom.png"),
  BluebusMapbottom: require("../Assets/images/BluebusMapbottom.png"),
  BrownbusMapbottom: require("../Assets/images/BrownbusbottomMap.png"),
  YellowbusMapbottom: require("../Assets/images/YellowBusMapBottom.png"),
  MapVehicle: require("../Assets/images/MapVehicleee.png"),
  MapVehicleWhite: require("../Assets/images/MapVehicleWhiteee.png"),
  Drawer: require("../Assets/images/Drawer.png"),
  Users: require("../Assets/images/Userss.png"),
  VehicleExpence: require("../Assets/images/VehicleExpence.png"),
  Dispatch: require("../Assets/images/Dispatch.png"),
  Payment: require("../Assets/images/Payment.png"),
  MasretData: require("../Assets/images/MasterData.png"),
  Config: require("../Assets/images/Config.png"),
  BottomCrop: require("../Assets/images/BottomCrop.png"),

  Report: require("../Assets/images/Report.png"),
  PickUpCar: require("../Assets/images/PickupCar.png"),
  PickUpVehicle: require("../Assets/images/PickUpVehicle.png"),
  PickUpOrder: require("../Assets/images/PickupOrders.png"),
  StarYellow: require("../Assets/images/StarYellow.png"),
  Starwhite: require("../Assets/images/StarWhite.png"),
  PickUpOrderDestintin: require("../Assets/images/OrderDestination.png"),
  UpwordMessage: require("../Assets/images/UpwordMessage.png"),
  DownWordMessage: require("../Assets/images/DownwordMessage.png"),
  SmallCar: require("../Assets/images/SmallCar.png"),
  CopyLink: require("../Assets/images/CopyLink.png"),
  EmailShare: require("../Assets/images/EmailShare.png"),
  WhatsappShare: require("../Assets/images/WhatsappShare.png"),
  SmsShare: require("../Assets/images/SmsShare.png"),
  MapMessage: require("../Assets/images/MessageMap.png"),
  MsgSpeed: require("../Assets/images/SpeedoMetermsg.png"),
  MsgOn: require("../Assets/images/Onmsg.png"),
  MsgCar: require("../Assets/images/BlackCarmsg.png"),
  MsgSat: require("../Assets/images/Satlitemsg.png"),
  Reduparrow: require("../Assets/images/Redarrowup.png"),
  Greendownarrow: require("../Assets/images/Greenarrowdown.png"),
  TriangleOrangeAlert: require("../Assets/images/TriangleOrangeAlert.png"),
  TriangleRedAlert: require("../Assets/images/TriangleRedAlert.png"),
  GreenRoundTick: require("../Assets/images/GreenRounTick.png"),
  Dualimage: require("../Assets/images/Dualimage.png"),
  LeftCalenderArrow: require("../Assets/images/LeftCalenderArrow.png"),
  RightCalenderArrow: require("../Assets/images/RightCalenderArrow.png"),
  BottomDashboardInactive: require("../Assets/images/BottomDashboardInactive.png"),
  BottomMastersettingActive: require("../Assets/images/BottomMastersettingActive.png"),
  BottomMasterDataActive: require("../Assets/images/BottomMasterDataActive.png"),
  BottomUsersActive: require("../Assets/images/BottomUsersActive.png"),
  BottomTripActive: require("../Assets/images/BottomTripActiveTwo.png"),
  BottomVehicleExpenceActive: require("../Assets/images/BottomVehicleExpenceActive.png"),
  BottomDispatchManagementActive: require("../Assets/images/BottomDispatchActive.png"),
  BottomPaymentActive: require("../Assets/images/BottomPaymentActive.png"),
  BottomCommunicationActive: require("../Assets/images/BottomCommunicationActiveTwo.png"),
  BottomReportActive: require("../Assets/images/BottomReportActive.png"),
  BottomConfigActive: require("../Assets/images/BottomConfigCheckerActive.png"),
  BottomAccontActive: require("../Assets/images/BottomAccountActivetwo.png"),
  BottomUserInsightActive: require("../Assets/images/BottomUserInsightsActive.png"),
  BottomUserInsightInActive: require("../Assets/images/BottomUserInsightsInactive.png"),
  BottomInspection: require("../Assets/images/BottomVehicleinspectionActive.png"),
  BottomInspectionIns: require("../Assets/images/vegicleins.png"),

  // ToolsBottom:require("../Assets/images/"),
  //----------------------Nandu------------------------//

  Plus: require("../Assets/images/Plus.png"),
  Backbtn: require("../Assets/images/Backbtn.png"),
  Bellnoti: require("../Assets/images/Bellnoti.png"),
  Boycircle: require("../Assets/images/Boycircle.png"),
  Threedots: require("../Assets/images/Threedots.png"),
  Brownround: require("../Assets/images/Brownround.png"),

  Boypicture: require("../Assets/images/Boypicture.png"),
  Boypicture: require("../Assets/images/Boypicture.png"),
  Warning: require("../Assets/images/Warning.png"),
  Greentick: require("../Assets/images/Greentick.png"),
  search: require("../Assets/images/search.png"),
  Shareit: require("../Assets/images/Shareit.png"),
  Cameraman: require("../Assets/images/Cameraman.png"),
  Greyclose: require("../Assets/images/Greyclose.png"),
  Rgblight: require("../Assets/images/Rgblight.png"),
  Smartboy: require("../Assets/images/Smartboy.png"),
  UploadDoc: require("../Assets/images/UploadDoc.png"),
  BFile: require("../Assets/images/BFile.png"),
  Cloudss: require("../Assets/images/Cloudss.png"),
  // DrawerIcon: require("../Assets/images/DrawerIcon.png"),
  Dispatchtrip: require("../Assets/images/Dispatchtrip.png"),
  MyLocation: require("../Assets/images/MyLocation.png"),
  LightBus: require("../Assets/images/LightBus.png"),
  MyLocation1: require("../Assets/images/MyLocation1.png"),
  Delpic: require("../Assets/images/Delpic.png"),
  Danger: require("../Assets/images/Danger.png"),
  //SMR
  blurMap: require("../Assets/images/blurMap.png"),
  profileAddon: require("../Assets/images/profileAddon.png"),
  profileDispa: require("../Assets/images/profileDispa.png"),
  profileInte: require("../Assets/images/profileInte.png"),
  profilePic: require("../Assets/images/profilePic.png"),
  profileRight: require("../Assets/images/profileRight.png"),
  profileSettings: require("../Assets/images/profileSettings.png"),
  profileTrans: require("../Assets/images/profileTrans.png"),
  profileNoti: require("../Assets/images/profileNoti.png"),
  theCar: require("../Assets/images/theCar.png"),
  companyBack: require("../Assets/images/companyBack.png"),
  companyPro: require("../Assets/images/companyPro.png"),
  proCamera: require("../Assets/images/proCamera.png"),
  mapDel: require("../Assets/images/mapDel.png"),
  mapPlus: require("../Assets/images/mapPlus.png"),
  mapSquare: require("../Assets/images/mapSquare.png"),
  mapZoom: require("../Assets/images/mapZoom.png"),
  brownCircle: require("../Assets/images/brownCircle.png"),
  blackcar: require("../Assets/images/blackcar.png"),
  bluecar: require("../Assets/images/bluecar.png"),
  redcar: require("../Assets/images/redcar.png"),
  yellowcar: require("../Assets/images/yellowcar.png"),
  greencar: require("../Assets/images/greencar.png"),
  flagdark: require("../Assets/images/flagdark.png"),
  flaglight: require("../Assets/images/flaglight.png"),
  browse: require("../Assets/images/browse.png"),
  cameraPic: require("../Assets/images/cameraPic.png"),
  galleryPic: require("../Assets/images/galleryPic.png"),
  vaccation: require("../Assets/images/vaccation.png"),
  pointInt: require("../Assets/images/pointInt.png"),
  parking: require("../Assets/images/parking.png"),
  Holiday: require("../Assets/images/Holiday.png"),
  geofence: require("../Assets/images/geofence.png"),
  carVechicle: require("../Assets/images/carVechicle.png"),
  transMan: require("../Assets/images/transMan.png"),
  fleetcar: require("../Assets/images/fleetcar.png"),
  deliMan: require("../Assets/images/deliMan.png"),
  darkDriver: require("../Assets/images/darkDriver.png"),
  assist: require("../Assets/images/assist.png"),
  admini: require("../Assets/images/admini.png"),
  trip: require("../Assets/images/trip.png"),
  stop: require("../Assets/images/stop.png"),
  vechicleAcc: require("../Assets/images/vechicleAcc.png"),
  sparePart: require("../Assets/images/sparePart.png"),
  fuelEx: require("../Assets/images/fuelEx.png"),
  fleetMain: require("../Assets/images/fleetMain.png"),
  fineVechcle: require("../Assets/images/fineVechcle.png"),
  backVechicle: require("../Assets/images/backVechicle.png"),
  customerDis: require("../Assets/images/customerDis.png"),
  orderDis: require("../Assets/images/orderDis.png"),
  paid: require("../Assets/images/paid.png"),
  invoice: require("../Assets/images/invoice.png"),
  email: require("../Assets/images/email.png"),
  commuNoti: require("../Assets/images/commuNoti.png"),
  announce: require("../Assets/images/announce.png"),
  accountmsg: require("../Assets/images/accountmsg.png"),
  accountPark: require("../Assets/images/accountPark.png"),
  accountPic: require("../Assets/images/accountPic.png"),
  language: require("../Assets/images/language.png"),
  lockscreen: require("../Assets/images/lockscreen.png"),
  replay: require("../Assets/images/replay.png"),
  supportCus: require("../Assets/images/supportCus.png"),
  accountFuel: require("../Assets/images/accountFuel.png"),
  accountCon: require("../Assets/images/accountCon.png"),
  loadPic: require("../Assets/images/loadPic.png"),
  docPic: require("../Assets/images/docPic.png"),
  defvech1: require("../Assets/images/defvech1.png"),
  defVech2: require("../Assets/images/defVech2.png"),
  defVech3: require("../Assets/images/defVech3.png"),
  defVech4: require("../Assets/images/defVech4.png"),
  defVech5: require("../Assets/images/defVech5.png"),
  defVech6: require("../Assets/images/defVech6.png"),
  reportDoc: require("../Assets/images/reportDoc.png"),
  AddRepo: require("../Assets/images/AddRepo.png"),
  lookRepo: require("../Assets/images/lookRepo.png"),
  subRepo: require("../Assets/images/subRepo.png"),
  radio1: require("../Assets/images/radio1.png"),
  radio2: require("../Assets/images/radio2.png"),
  addrow: require("../Assets/images/addrow.png"),
  addon: require("../Assets/images/addon.png"),
  delCart: require("../Assets/images/delCart.png"),

  teleact: require("../Assets/images/teleact.png"),
  whitetele: require("../Assets/images/whitetele.png"),
  smsact: require("../Assets/images/smsact.png"),
  whitesms: require("../Assets/images/whitesms.png"),
  pushact: require("../Assets/images/pushact.png"),
  whitepush: require("../Assets/images/whitepush.png"),
  whiteapp: require("../Assets/images/whiteapp.png"),
  whiteemail: require("../Assets/images/whiteemail.png"),
  emailact: require("../Assets/images/emailact.png"),
  appact: require("../Assets/images/appact.png"),

  offline: require("../Assets/images/offline.png"),
  wait: require("../Assets/images/wait.png"),
  online: require("../Assets/images/online.png"),
  callmsg: require("../Assets/images/callmsg.png"),
  msgBoy: require("../Assets/images/msgBoy.png"),
  msgGirl: require("../Assets/images/msgGirl.png"),
  passGo: require("../Assets/images/passGo.png"),
  lockPss: require("../Assets/images/lockPss.png"),

  MessageRound: require("../Assets/images/MessageRound.png"),
  PhoneRound: require("../Assets/images/PhoneRound.png"),

  RedDot: require("../Assets/images/RedDot.png"),
  GreenDot: require("../Assets/images/GreenDot.png"),
  BrownDot: require("../Assets/images/BrownDot.png"),
  MapDot: require("../Assets/images/MapDot.png"),
  BrownNon: require("../Assets/images/BrownNon.png"),
  UpDown: require("../Assets/images/UpDown.png"),
  Arrow123: require("../Assets/images/Arrow123.png"),
  YellowCarround: require("../Assets/images/YellowCarround.png"),
  Download: require("../Assets/images/Download.png"),
  DownArrow: require("../Assets/images/DownArrow.png"),
  Linedown: require("../Assets/images/Linedown.png"),
  RedCircle: require("../Assets/images/RedCircle.png"),
  YellowCircle: require("../Assets/images/YellowCircle.png"),
  FullCar: require("../Assets/images/FullCar.png"),
  MyCars: require("../Assets/images/MyCars.png"),
  BodyPartCar: require("../Assets/images/BodyPartCar.png"),
  RegCerti: require("../Assets/images/RegCerti.png"),
  InsureCopy: require("../Assets/images/InsureCopy.png"),
  LastServ: require("../Assets/images/LastServ.png"),
  Pollution: require("../Assets/images/Pollution.png"),
  NoImage: require("../Assets/images/NoImage.png"),
  DownloadTwo: require("../Assets/images/DownloadTwo.png"),
  BackWard: require("../Assets/images/BackWard.png"),
  ForWard: require("../Assets/images/ForWard.png"),
  ClutchPlate: require("../Assets/images/ClutchPlate.png"),
  CarPart: require("../Assets/images/CarPart.png"),
  TickGreen: require("../Assets/images/TickGreen.png"),
  NonGreen: require("../Assets/images/NonGreen.png"),
  dashImg: require("../Assets/images/dashImg.png"),
  vehicleImg: require("../Assets/images/vehicleImg.png"),
  notiMSG: require("../Assets/images/notiMSG.png"),
  notiMain: require("../Assets/images/notiMain.png"),
  notiAlert: require("../Assets/images/notiAlert.png"),
  lineNoti: require("../Assets/images/lineNoti.png"),
  Msgadd: require("../Assets/images/Msgadd.png"),
  Msgsnd: require("../Assets/images/Msgsnd.png"),
  VerifOtp: require("../Assets/images/VerifOtp.png"),
  AddTym: require("../Assets/images/AddTym.png"),
  redCross: require("../Assets/images/redCross.png"),
  pinkone: require("../Assets/images/pinkone.png"),
  blueone: require("../Assets/images/blueone.png"),
  redone: require("../Assets/images/redone.png"),
  yellowone: require("../Assets/images/yellowone.png"),
  greenone: require("../Assets/images/greenone.png"),
  nothingone: require("../Assets/images/nothingone.png"),
  orangeone: require("../Assets/images/orangeone.png"),
  aquaone: require("../Assets/images/aquaone.png"),
  Listedreport: require("../Assets/images/Listedreport.png"),
};

export default AppImages;
